import { render } from "./BaseMenuList.vue?vue&type=template&id=00154ea5&ts=true"
import script from "./BaseMenuList.vue?vue&type=script&lang=ts"
export * from "./BaseMenuList.vue?vue&type=script&lang=ts"

import "./BaseMenuList.vue?vue&type=style&index=0&id=00154ea5&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__